<template>
    <div class="input_container">
        <div v-if="props.labelText" class="label">{{ props.labelText }}</div>
        <van-row class="field_row">
            <van-col span="22" class="content">
                {{ props.content }}
            </van-col>
            <van-col span="2" v-if="props.isShowRightIcon" class="icon_image">
                <img :src="rightImage" alt="" @click="handleClick">
            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
import {} from 'vue'

const props = defineProps({
    labelText: {
        type: String,
        default: ''
    },
    leftImage: {
        type: String,
    },
    rightImage: {
        type: String,
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    content: {
        type: String,
    },
    opacityNone: {
        type: Boolean,
        default: () => false
    },
    bgColor: {
        type: String,
        default: () => ''
    }
})
const emits = defineEmits(['onClickRight'])

const handleClick = () => {
    emits('onClickRight')
}

</script>
<style scoped>

.input_container {
    padding: 7.5px 0 5px;
}

.label {
    font-size: 16px;
    color: #0167ca;
    padding: 7.5px 0;
}

.field_row {
    padding: 15px;
    background: #101629;
        border: .02667rem solid #151C2F;;
    border-radius: 8.25px;
}

.icon_image img {
    width: 17px;
    opacity: 1;
}

.content {
    display: flex;
    align-items: center;
    padding: 0 15px;
    font-size: 14px;
    color: #b9d1ff;
}
</style>